import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "wrapper" }
const _hoisted_2 = { class: "header_wrapper" }
const _hoisted_3 = { class: "content_wrapper" }
const _hoisted_4 = {
  key: 0,
  class: "d-flex align-center"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_spacer = _resolveComponent("v-spacer")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_vue_loading = _resolveComponent("vue-loading")!
  const _component_children_field = _resolveComponent("children-field")!
  const _component_v_form = _resolveComponent("v-form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_v_toolbar, {
        class: "fixed_toolbar",
        color: "primary",
        dark: ""
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            onClick: _ctx.routerBack,
            style: {"position":"absolute"},
            icon: ""
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[0] || (_cache[0] = [
                  _createTextVNode("mdi-chevron-left", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.childName), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_v_spacer),
          _createVNode(_component_v_btn, {
            onClick: _ctx.clickPost,
            loading: _ctx.btnLoading,
            class: "no-background-hover",
            style: {"position":"absolute","right":"20px"},
            icon: ""
          }, {
            default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
              _createTextVNode(" 保存 ", -1)
            ]))]),
            _: 1
          }, 8, ["onClick", "loading"])
        ]),
        _: 1
      })
    ]),
    _createElementVNode("div", _hoisted_3, [
      (_ctx.fetchLoading)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createVNode(_component_vue_loading, {
              loader: "bars",
              color: "#EE6090",
              size: { width: '30px', height: '30px' }
            })
          ]))
        : _createCommentVNode("", true),
      (!_ctx.fetchLoading && _ctx.answers.length)
        ? (_openBlock(), _createBlock(_component_v_form, {
            key: 1,
            ref: "post_childrenbasic_form",
            class: "form_wrapper px-2 py-3"
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.formats, (f, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: f.key
                }, [
                  _createVNode(_component_children_field, {
                    format: f,
                    answers: _ctx.answers,
                    index: index,
                    onInputValue: _ctx.inputValue
                  }, null, 8, ["format", "answers", "index", "onInputValue"])
                ]))
              }), 128))
            ]),
            _: 1
          }, 512))
        : _createCommentVNode("", true)
    ])
  ]))
}